import React from 'react'

export const IconArrowRight = ({ size = 20, color = '#222', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Prosseguir"
    {...props}
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);